import { styled } from '@nx-kit/styling';
import { InputRadio } from 'components/organisms/FormsSlice/Forms/Forms';

export const StyledInputRadio = styled(InputRadio)`
  accent-color: ${({ theme }) => theme.global.color.primary};
  height: 20px;
  min-width: 20px;
`;
